export const LEGAL_LINKS = [
  {
    key: 'affirmCanadaHelpLink',
    href: 'https://www.affirm.ca/help',
    text: 'affirm.ca/help',
  },
  {
    key: 'lendersLink',
    href: 'https://www.affirm.com/lenders',
    text: 'affirm.com/lenders',
  },
  {
    key: 'licensesLink',
    href: 'https://www.affirm.com/licenses',
    text: 'affirm.com/licenses',
  },
];
